import React from 'react';

interface KafkaStatusProps {
  consumerLag: Record<string, number>;
  producerQueueSize: number;
}

function getLagColor(lag: number): string {
  if (lag === 0) return 'text-green-600 bg-green-50';
  if (lag < 100) return 'text-yellow-600 bg-yellow-50';
  if (lag < 1000) return 'text-orange-600 bg-orange-50';
  return 'text-red-600 bg-red-50';
}

export function KafkaStatus({
  consumerLag,
  producerQueueSize,
}: KafkaStatusProps) {
  return (
    <div className="bg-white rounded-lg p-6 border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        Kafka Status
      </h3>

      <div className="mb-6">
        <h4 className="text-sm font-medium text-gray-600 mb-3">
          Consumer Lag by Topic
        </h4>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Topic
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Lag
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {Object.entries(consumerLag).map(([topic, lag]) => (
                <tr key={topic}>
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                    {topic}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                    {lag.toLocaleString()}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span
                      className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getLagColor(
                        lag
                      )}`}
                    >
                      {lag === 0
                        ? 'No Lag'
                        : lag < 100
                        ? 'Low'
                        : lag < 1000
                        ? 'Medium'
                        : 'High'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <h4 className="text-sm font-medium text-gray-600 mb-2">
          Producer Queue
        </h4>
        <p className="text-2xl font-bold text-gray-900">
          {producerQueueSize.toLocaleString()}
        </p>
        <p className="text-xs text-gray-500 mt-1">messages in queue</p>
      </div>
    </div>
  );
}
